import _, { isNil, isEqual, map } from 'lodash';
import { VIZ_OPTION_IDS } from '../../common';
import Util from '../../common/Util';
import { IDehydratedViz } from '../../discovery/interfaces';

/**
 * Sanitizes the content for export or comparison.
 * @param allContent Array of visualizations to sanitize
 * @param filteredContent
 * @param search Optional search string to filter content
 * @returns Sanitized array of visualizations
 */
export function sanitizeLibraryContent(
  allContent: (IDehydratedViz & { description: string })[],
  filteredContent?: (IDehydratedViz & { description: string })[],
  search?: string,
) {
  const contentToClean = filteredContent
    ? _.filter(
        filteredContent,
        v =>
          !search ||
          [v.name, v.description, v.creatorName].some(
            field =>
              !isNil(field) &&
              field.toLowerCase().includes(search?.toLowerCase()),
          ),
      )
    : allContent;

  return _(Util.removeTypeNameRecursively(contentToClean))
    .map(v => ({
      ..._.omit(v, [
        'dataset',
        'isPrivate',
        '__typename',
        'creatorName',
        'creator',
        'createdOn',
        'updatedByName',
        'updatedOn',
        'canDelete',
        'canUpdate',
        'description',
      ]),
      datasetName: v.dataset.name,
      datasetId: v.dataset.id,
      private: !!v.isPrivate,
      layout: map(v.layout, x => _.omit(x, '__typename')),
      options: map(v.options, x => ({
        ..._.omit(x, '__typename'),
        ...(isEqual(x.key, VIZ_OPTION_IDS.slicerSelections) && {
          value: '[]',
        }),
      })),
    }))
    .value();
}
